import {useEffect, useState} from "react";
import {useApp} from "../Contex";
import {fetchProfile, updatePassword, updateUser} from "../api/api";
import BottomSheet from "../components/BottomSheet";

export default function AccountSettings() {
    const {refresh} = useApp()
    const [user, setUser] = useState({});
    const [update, setUpdate] = useState({});
    const [loading, setLoading] = useState(false);
    const [changePassword, setChangePassword] = useState(false);

    const fetchData = () => {
        setLoading(true);
        fetchProfile().then(res => {
            if (res.ok) {
                console.log(res)
                setUser(res.profile)
                setUpdate(res.profile)
            }
        })
        setLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, [refresh]);

    const updateEmail = () => {
        updateUser(update).then(res=>{
            if(res.ok){
                fetchData()
            }
        })
    }

    return <>
        <h1>Inställningar</h1>

            <div className="card rounded rounded-4 shadow-sm p-3">
                {loading ?
                    <div className="text-center"><span className="spinner-border text-secondary"/></div>
                    :
                    <>
                        <h3>Användaruppgifter</h3>
                        <div className="d-flex gap-2 align-items-center">
                            <label>Epost</label>
                            <input className="form-control w-auto" value={update.email ?? ""} onChange={(e) => {setUpdate(prev => ({ ...prev, email: e.target.value }))}} />
                            {user.email !== update.email && <button className="btn btn-success" onClick={updateEmail}>Spara</button>}
                        </div>
                        <button className="btn btn-outline-danger mt-2 w-50" onClick={()=>{setChangePassword(true)}}>
                            Byt lösenord
                        </button>
                    </>
                }
            </div>

        <PasswordModal/>
    </>

    function PasswordModal(){
            const [formData, setFormData] = useState({old: "", new: "", confirm: ""})
        const [error, setError] = useState(null)

        function handleSubmit(){
            if(formData.new !== formData.confirm){
                setError("Lösenord matchar inte")
            }else{
                updatePassword(formData.new, formData.old ).then(res=>{
                    if(res.ok){
                        if(res.updated){
                            setChangePassword(false)
                        }else{
                            setError(res.error)
                        }
                    }
                })
            }
        }

        function handleChange(e){
                setFormData({...formData, [e.target.name]: e.target.value})
            setError(null)
        }

        return <BottomSheet show={changePassword} setShow={setChangePassword}>
            <h1 className="mb-3">Skapa nytt lösenord</h1>
            {error && <div className="card bg-danger-subtle mb-2 p-2">
                <span>{error}</span>
            </div>}
            <label>Tidigare lösenord</label>
            <input className="form-control mb-2" value={formData.old} name="old" onChange={handleChange} type="password"/>
            <label>Nytt lösenord</label>
            <input className="form-control mb-2" value={formData.new} name="new" onChange={handleChange} type="password"/>
            <label>Upprepa lösenord</label>
            <input className="form-control" value={formData.confirm} name="confirm" onChange={handleChange} type="password"/>
            <div className="mt-3 text-end">
                <button className="btn btn-success" onClick={handleSubmit}>Spara lösenord</button>
            </div>
        </BottomSheet>
    }
}
